import { FunctionComponent, useEffect, useState } from "react";
import Pages from "./pages";
import { supabase } from "libs/supabase";
import { Asset, Configurator } from "@rromikas/configurio";
import LoadingProvider from "providers/loading";

interface TestPagesProps {}

const newConfigurator: Configurator = {
  options: { customizers: [], groups: [] },
  model_url:
    "https://cgyoyxveuhcdkioxzkcp.supabase.co/storage/v1/object/sign/model/1683070103367.glb?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJtb2RlbC8xNjgzMDcwMTAzMzY3LmdsYiIsImlhdCI6MTY4MzA3MDEwNCwiZXhwIjoyNTQ3MDcwMTA0fQ.HyxD-m1R_dcGVHnIaobnCDQfdgCXSOOIoevEVYdMdbA",
  model_image_url:
    "https://cgyoyxveuhcdkioxzkcp.supabase.co/storage/v1/object/sign/images/1683070107182.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJpbWFnZXMvMTY4MzA3MDEwNzE4Mi5wbmciLCJpYXQiOjE2ODMwNzAxMDcsImV4cCI6MjU0NzA3MDEwN30.f1ewLoxY9YcCzxokopCO4mHme9ngZLZN65iF_4daZ4U",
  name: "",
  product_title: "",
  base_price: 0,
};

const newAsset: Asset = {
  type: "material",
  image_url:
    "https://cgyoyxveuhcdkioxzkcp.supabase.co/storage/v1/object/sign/images/1683914377824.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJpbWFnZXMvMTY4MzkxNDM3NzgyNC5wbmciLCJpYXQiOjE2ODM5MTQzNzgsImV4cCI6MjU0NzkxNDM3OH0.sQxRjZ9QmQ73Go_VjA_ALNtgRzfssNIfzX3jcFxQUTU",
  url: "https://cgyoyxveuhcdkioxzkcp.supabase.co/storage/v1/object/sign/material/1683914345891.glb?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJtYXRlcmlhbC8xNjgzOTE0MzQ1ODkxLmdsYiIsImlhdCI6MTY4MzkxNDM0NiwiZXhwIjoyNTQ3OTE0MzQ2fQ.J004Azkuto3nRQv9KP5UNaDHQjNJBr0pJpvHqYbZXLk",
};

const TestPages: FunctionComponent<TestPagesProps> = () => {
  const [isPreparedForTesting, setIsPreparedForTesting] = useState(false);
  useEffect(() => {
    const deleteAll = async (table: string) => {
      await supabase
        .from(table)
        .select("*")
        .then((res) => {
          if (res.data) {
            return supabase
              .from(table)
              .delete()
              .in(
                "id",
                res.data.map((x) => x.id)
              );
          }
        });
    };

    const initializeTestData = async () => {
      await supabase.auth.signInWithPassword({
        email: process.env.REACT_APP_SUPABASE_TEST_EMAIL as string,
        password: process.env.REACT_APP_SUPABASE_TEST_PASSWORD as string,
      });
      await Promise.all([deleteAll("assets"), deleteAll("configurators")]);
      await Promise.all([supabase.from("configurators").insert(newConfigurator), supabase.from("assets").insert(newAsset)]);
      setIsPreparedForTesting(true);
    };

    initializeTestData();
  }, []);

  return !isPreparedForTesting ? null : (
    <LoadingProvider>
      <Pages basename="/test" />
    </LoadingProvider>
  );
};

export default TestPages;
